module.exports = ".help-button{margin-left:0.5rem;cursor:pointer;display:inline-flex}.help-icon{font-size:1.25em}\n"